import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.typed.float32-array.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.typed.uint32-array.js";
// Decode the binary structure-of-arrays quadtree payload emitted by
// worker/workersc into the typed-array descriptor used by the renderer hot path.
// Wire format (little-endian, 20 + 17N bytes, gzipped at rest):
//   u32 nNodes | f32[4] bounds | u32[N] cellIds | f32[N] x | f32[N] y |
//   u32[N] subtreeDelta | u8[N] childMask
// unpackResult gunzips the object and hands this function the raw Uint8Array.

var HEADER_BYTES = 20; // nNodes u32 + bounds f32[4]

var parseEmbeddingQuadtree = function parseEmbeddingQuadtree(raw) {
  if (!(raw instanceof Uint8Array)) throw new Error('Invalid embedding payload');
  if (raw.byteLength < HEADER_BYTES) throw new Error('Malformed embedding payload: truncated header');

  // Typed-array views require a 4-aligned start. fflate's decompress and the
  // socket path's Uint8Array.from() both give byteOffset 0, so this never fires
  // in practice -- but relying on an allocator invariant would surface as a raw
  // "start offset should be a multiple of 4" TypeError, so normalise instead.
  var src = raw.byteOffset % 4 === 0 ? raw : new Uint8Array(raw);
  var buffer = src.buffer;
  var base = src.byteOffset;
  var nNodes = new DataView(buffer, base, HEADER_BYTES).getUint32(0, true);

  // 20 + 17N is the single strongest integrity check available for free; a
  // truncated body becomes a clear error instead of a RangeError from a view.
  var expected = HEADER_BYTES + 17 * nNodes;
  if (src.byteLength !== expected) {
    throw new Error("Malformed embedding payload: ".concat(src.byteLength, " bytes, expected ").concat(expected, " for ").concat(nNodes, " nodes"));
  }

  // bounds is a copy (not a view): it must stay an independent Float32Array
  // (plotUtils snapBucketToQuadtree consumes it) and outlive the big buffer.
  var bounds = new Float32Array(buffer.slice(base + 4, base + HEADER_BYTES));
  var o = base + HEADER_BYTES;
  var cellIds = new Uint32Array(buffer, o, nNodes);
  o += 4 * nNodes;
  var xValues = new Float32Array(buffer, o, nNodes);
  o += 4 * nNodes;
  var yValues = new Float32Array(buffer, o, nNodes);
  o += 4 * nNodes;
  var subtreeEnd = new Uint32Array(buffer, o, nNodes);
  o += 4 * nNodes;
  var childMask = new Uint8Array(buffer, o, nNodes);

  // Reconstruct absolute subtreeEnd from the stored delta, in place over the same
  // view (no second allocation). delta === 0 can only mean a corrupt object,
  // because the writer guarantees subtreeEnd[i] >= i + 1.
  for (var i = 0; i < nNodes; i += 1) {
    var d = subtreeEnd[i];
    if (d === 0) throw new Error("Malformed embedding payload: zero subtree delta at node ".concat(i));
    subtreeEnd[i] = i + d;
  }
  return {
    nNodes: nNodes,
    bounds: bounds,
    cellIds: cellIds,
    xValues: xValues,
    yValues: yValues,
    subtreeEnd: subtreeEnd,
    childMask: childMask
  };
};
export default parseEmbeddingQuadtree;